import ScriptSummaryContainer from './ScriptSummaryContainer';
import { connect } from 'react-redux';
import { getAccountCountry, isVolumeTypeSwitchEnabled, getBagSizeForCrop } from 'user/selectors';
import {
  getApplicationTypeForScriptType,
  getCropIdForScript,
  getEditProductApplicationSummary,
  getNumZonesForScript,
  getScriptTypeForScript,
  scriptTypeIsNitrogen,
  getCropForScript
} from 'scripts/selectors';
import {
  getNitrogenApplicationRateType,
  getActiveScript
} from 'current/selectors';

import { getNominalWeightByScript} from 'crops/selectors';
import { getNumZonesWithProductApplications } from 'scripts/zones/productApplication-selectors';

import { scriptTypes } from 'constants/scripts';
import isCustom from 'util/isCustom';

export default connect(
  state => {
    const script = getActiveScript(state);
    const scriptType = script && getScriptTypeForScript(script);

    return {
      accountCountry: getAccountCountry(state),
      applicationType: getApplicationTypeForScriptType(scriptType),
      bagSize: scriptType === scriptTypes.PLANTING ? getBagSizeForCrop(state, getCropForScript(script)) : '',
      cropId: getCropIdForScript(state, script),
      cropNominalWeight: getNominalWeightByScript(state, script),
      numPopulatedZones: getNumZonesWithProductApplications(script),
      numZones: getNumZonesForScript(script),
      script: script,
      scriptType,
      scriptTypeIsNitrogen: scriptTypeIsNitrogen(script),
      summary: getEditProductApplicationSummary(state, script),
      showEditAllButton: 
        scriptTypeIsNitrogen(script) && !isCustom(script) && isVolumeTypeSwitchEnabled(state),
      nitrogenApplicationRateType: getNitrogenApplicationRateType(state),
      isCustom: isCustom(script)
    };
  }
)(ScriptSummaryContainer);
